import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchProductList, fetchProductConfig } from '../services/productService';

// Async thunk lấy danh sách products
export const getProducts = createAsyncThunk(
    'product/getProducts',
    async (filters, thunkAPI) => {
        const { token, secretKey, stime } = thunkAPI.getState().auth;

        if (!token || !secretKey || !stime) {
            return thunkAPI.rejectWithValue('Missing auth credentials');
        }

        try {
            const res = await fetchProductList(filters, token, stime, secretKey);
            return res;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || 'Lỗi khi gọi API sản phẩm');
        }
    }
);

// Async thunk lấy cấu hình sản phẩm
export const getProductConfig = createAsyncThunk(
    'product/getProductConfig',
    async (_, thunkAPI) => {
        const { token, secretKey, stime } = thunkAPI.getState().auth;

        if (!token || !secretKey || !stime) {
            return thunkAPI.rejectWithValue('Missing auth credentials');
        }

        try {
            const res = await fetchProductConfig(token, stime, secretKey);
            return res;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || 'Lỗi khi gọi API cấu hình sản phẩm');
        }
    }
);

const productSlice = createSlice({
    name: 'product',
    initialState: {
        data: [],
        total: 0,
        loading: false,
        error: null,
        config: {
            status: [],
            category: [],
            providers: [],
            products: [],
        },
        configLoading: false,
        configError: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // xử lý getProducts
            .addCase(getProducts.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getProducts.fulfilled, (state, action) => {
                const response = action.payload;
                state.data = response?.data?.data || [];
                state.total = response?.data?.total || 0;
                state.loading = false;
            })
            .addCase(getProducts.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // xử lý getProductConfig
            .addCase(getProductConfig.pending, (state) => {
                state.configLoading = true;
                state.configError = null;
            })
            .addCase(getProductConfig.fulfilled, (state, action) => {
                const configData = action.payload?.data || {};
                state.config.status = configData.status || [];
                state.config.category = configData.insuranceCategory || [];
                state.config.providers = configData.providers || [];
                state.config.products = configData.products || [];
                state.configLoading = false;
            })
            .addCase(getProductConfig.rejected, (state, action) => {
                state.configLoading = false;
                state.configError = action.payload;
            });
    },
});

export default productSlice.reducer;